import React, { useMemo, createContext } from 'react';

import { getSearchDData } from 'utility/Extract/getSearchDData';
import { getCheck24Namespace } from 'utility/Provide/Namespace/getCheck24Namespace';

import { GlobalNamespace } from 'types/legacy/namespace';

export const CommunicationContext = createContext<GlobalNamespace>(
    getCheck24Namespace()
);
export const CommunicationProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const communicationData = useMemo(getCheck24Namespace, []);
    return (
        <CommunicationContext.Provider value={communicationData}>
            {children}
        </CommunicationContext.Provider>
    );
};

export const SearchDContext = createContext(getSearchDData());
export const SearchDProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const searchDData = useMemo(getSearchDData, []);
    return (
        <SearchDContext.Provider value={searchDData}>
            {children}
        </SearchDContext.Provider>
    );
};
